<template>
  <div>
    <CountPopup v-show="type == 0" />
    <CountDownSmall
      v-if="type === 1 && countList"
      :count="countList"
      :state="state"
      @close="onClose"
    />
  </div>
</template>

<script>
import { Form, FormItem, Input, Radio, RadioGroup } from "element-ui";
import { mapGetters } from "vuex";
import { getParameter } from "@/utils/global";
import { getCD } from "@/api/liveRequest/countDown";
import CountPopup from "./countPopup.vue";
import CountDownSmall from "./countDownSmall.vue";
import {
  pushRoomMessageFunc,
  removeMessageFunc,
} from "@/utils/socketMessageDispose";
export default {
  name: "countDown",
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    CountPopup,
    CountDownSmall,
  },
  data() {
    return {
      liveId: getParameter("liveId"),
      type: 0,
      isStart: false,
      count: undefined,
      timer: undefined,
      countList: undefined,
      state: -1
    };
  },
  computed: {
    ...mapGetters(["isShowCountDown", "sid", "liveToken"]),
  },
  watch: {
    liveToken: {
      immediate: true,
      handler(val) {
        val && this.getCount();
      }
    },
  },
  created() {
    pushRoomMessageFunc(this.message_event);
    document.addEventListener("visibilitychange", this.pageShow)
  },
  beforeDestroy() {
    document.removeEventListener("pageshow", this.pageShow)
    removeMessageFunc(this.message_event)
  },
  methods: {
    message_event({ cmd, requestData }) {
      switch (cmd) {
        case 7127:
          this.message_7127(requestData);
          break;
      }
    },
    message_7127(body) {
      switch (body.event) {
        case "countDown":
          this.$store.commit("SET_SHOW_COUNT_DOWN", false);
          if (body.state === 2) {
            this.isStart = false
            this.timer && clearInterval(this.timer);
            this.onClose();
          } else if( body.state === 4) {
            this.isStart = false
            this.timer && clearInterval(this.timer);
          } else{
            this.type = 1;
            this.isStart = true
            this.setCount(body.countDownInfo);
          }
          this.state = body.state;
          this.calcDate(
            body.countDownInfo,
            body.countDownInfo.remainingTime,
            body.state === 2
          );
          break;
      }
    },
    onClose() {
      this.type = 0;
      this.$store.commit("SET_SHOW_COUNT_DOWN", false);
    },
    pageShow() {
      if (document.visibilityState === "visible") {
        this.getCount()
      }
    },
    async getCount() {
      try {
        const { code, data } = await getCD(this.liveId);
        if (code === 200) {
          this.type = 1;
          this.setCount(data);
        } else if (code === 60000 && this.count) {
          this.timer && clearInterval(this.timer);
          if (this.isStart) {
            this.calcDate(this.count, 0, true)
          }
        }
      } catch (error) {
        console.error("Count Down::", error);
      }
    },
    calcDate(data, num, isEnd = false) {
      const total = data.duration * 60;
      num = Math.min(num, total);
      const str = data.timeType === 0 ? num : total - num;
      this.countList = [
        (str / 600) >> 0,
        (str / 60) % 10 >> 0,
        ((str % 60) / 10) >> 0,
        str % 10 >> 0,
        isEnd || num <= 0,
      ];
    },
    setCount(data) {
      this.count = data
      let num = data.remainingTime;
      this.calcDate(data, num);
      this.timer && clearInterval(this.timer);
      this.state = data.state;
      if(data.state === 4){
        return;
      }
      this.timer = setInterval(() => {
        if (num > 0) {
          num -= 1;
        } else {
          clearInterval(this.timer);
        }
        this.calcDate(data, num);
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
